import { FormGroup, Validators, FormControl } from '@angular/forms';
import * as i0 from "@angular/core";
export class GenerateAnalysisFormgroupService {
    getGenerateAnalysisFormgroup() {
        let analysisFormgroup;
        analysisFormgroup = new FormGroup({
            operationNumber: new FormControl('', [Validators.required]),
            language: new FormControl('', Validators.required),
            auditDate: new FormControl('', Validators.required),
            controlReport: new FormControl('', Validators.required),
            reviewDocument: new FormControl(''),
            ICRDocument: new FormControl(''),
            minPage: new FormControl(undefined),
            maxPage: new FormControl(undefined),
        });
        return analysisFormgroup;
    }
}
GenerateAnalysisFormgroupService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GenerateAnalysisFormgroupService_Factory() { return new GenerateAnalysisFormgroupService(); }, token: GenerateAnalysisFormgroupService, providedIn: "root" });
